/**
 * Mindestbesatzung — Spiegel von apps/api vehicleCatalog.inferCrewMin / BY_TYPE.
 * Bei Katalog-Änderungen hier mitpflegen (Admin-Overrides kommen erst mit Stats-API).
 */

const BY_TYPE: Record<string, number> = {
  LF: 6,
  HLF: 6,
  TSF: 4,
  MTF: 2,
  TLF: 2,
  DLK: 2,
  RW: 2,
  SchlauchW: 2,
  ELW: 1,
  ELW1: 1,
  ELW2: 2,
  "GW-Atemschutz": 1,
  "GW-Oel": 1,
  "GW-Gefahrgut": 2,
  "GW-Mess": 1,
  "GW-Hoehe": 2,
  "Dekon-P": 2,
  "GW-L1": 1,
  "GW-L2": 1,
  WLF: 1,
  Luefter: 1,
  NEA50: 1,
  NEA200: 1,
  "GW-UAS": 1,
  "GW-Verpflegung": 2,
  "MTW-Verpflegung": 2,
  "RW-Schiene": 2,
  "HLF-Schiene": 4,
  FLF: 2,
  RTF: 2,
  "GW-Werk": 2,
  FuStW: 1,
  "FuStW-DGL": 1,
  "BAB-FuStW": 1,
  Motorrad: 1,
  KDD: 1,
  DHuFueKw: 1,
  GefKw: 1,
  FueKw: 2,
  LeBefKw: 2,
  GruKw: 6,
  WaWe: 3,
  "SEK-ZF": 2,
  "SEK-MTF": 4,
  "MEK-ZF": 2,
  "MEK-MTF": 3,
  PferdeTrans: 1,
  PolHeli: 2,
  SWagen: 2,
  "WSP-Boot": 2,
  RTW: 2,
  NEF: 2,
  KTW: 2,
  NHW: 2,
  GRTW: 2,
  NAW: 3,
  ITW: 2,
  RTH: 2,
  RHS: 2,
  GKW: 4,
  "MTW-TZ": 4,
  "MTW-OV": 4,
  "LKW-K9": 1,
  MLW5: 3,
  BRmG: 1,
  TauchKW: 2,
  "MTW-O": 2,
  MLW4: 2,
  "MzGW-SB": 2,
  "LKW-E": 1,
  "MTW-UL": 2,
  FueKomKW: 2,
  FmKW: 2,
  Boot: 2,
  "GW-Wasser": 2,
  "GW-Taucher": 2,
  "GW-Berg": 2,
  ATV: 1,
  SRB: 2,
  SRK: 4,
  Abschlepper: 1,
  MSW: 1,
};

function guessOrg(type: string): "ems" | "other" {
  if (/RTW|KTW|NEF|NAW|ITW|RTH|GRTW|NHW|RHS|Rettung/i.test(type)) return "ems";
  return "other";
}

export function catalogCrewMin(type: string | undefined, seats: number): number {
  if (seats <= 0) return 0;
  if (!type) return Math.min(seats, Math.max(1, Math.ceil(seats * 0.5)));
  if (BY_TYPE[type] != null) return Math.min(seats, BY_TYPE[type]);
  if (guessOrg(type) === "ems") return Math.min(seats, Math.max(2, Math.ceil(seats * 0.75)));
  if (seats >= 6) return Math.min(seats, Math.max(4, Math.ceil(seats * (2 / 3))));
  if (seats >= 3) return Math.min(seats, Math.max(1, seats - 1));
  return Math.min(seats, Math.max(1, seats === 2 ? 1 : seats));
}
